import { KeyboardEvent, useEffect, useState } from 'react';

import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import { LexicalEditor } from 'lexical';

import { Input } from 'lib/common/components/Input';
import Modal from 'lib/common/components/Modal';

import addProtocolToUrl from './utils/addProtocolToUrl';
import updateLink from './utils/updateLink';

export default function EditLinkModal({
  initialLink,
  open,
  onClose,
  editor,
}: {
  initialLink: string | null;
  open: boolean;
  onClose: (link: string | null) => void;
  editor: LexicalEditor;
}) {
  // Use state instead of useRef because we need to focus the input after the ref is set (not modal open which takes focus) and requires a re-render
  const [inputRef, setInputRef] = useState<HTMLInputElement | null>(null);

  const [link, setLink] = useState(initialLink);

  const onInputKeyDown = (event: KeyboardEvent) => {
    if (event.key !== 'Enter') {
      return;
    }

    event.preventDefault();

    updateLink(editor, link);

    onClose(addProtocolToUrl(link));
  };

  const onSave = () => {
    updateLink(editor, link);

    onClose(addProtocolToUrl(link));
  };

  useEffect(() => {
    setLink(initialLink);
  }, [open]);

  useEffect(() => {
    inputRef?.focus();
  }, [inputRef]);

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose(initialLink);

        if (link) {
          return;
        }

        editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
      }}
      onSave={onSave}
      title={initialLink ? 'Edit Link' : 'Add a Link'}
    >
      <Input
        value={link}
        onChange={(event) => {
          setLink(event.target.value);
        }}
        inputProps={{
          ref: setInputRef,
        }}
        onKeyDown={onInputKeyDown}
      />
    </Modal>
  );
}
